import { Link, useNavigate } from "react-router-dom";
import style from "./logout.module.scss";
import { loginURL } from "../helpers/constant-words";
import { useAuth } from "../../context/Auth/AuthState";
import useTheme from "../useTheme/useTheme";

const LogoutText = () => {
  const { theme } = useTheme();
  const auth = useAuth();
  const navigate = useNavigate();

  const handlelogout = () => {
    auth.logout();

    navigate(loginURL, { replace: true });
  };

  return (
    <div
      className={`${style.notice} ${
        theme === "light" ? "text-black" : "text-white"
      }`}
    >
      <div className={style.anchor} onClick={handlelogout}>
        Click here
      </div>{" "}
      to save & exit
    </div>
  );
};

export default LogoutText;
